// Presets for React-Motion: https://github.com/chenglou/react-motion
export const MOTION_PRESETS = {
  FAST: {
    stiffness: 300,
    damping: 28,
  },
  SMOOTH: {
    stiffness: 200,
    damping: 24,
  },
  SLOW: {
    stiffness: 150,
    damping: 22,
  },
};
